"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../model/utils");
var wrapper_1 = require("../utils/wrapper");
var constant_1 = require("../utils/constant");
var fetchNotifications = function () {
    return wrapper_1.getClients().restClient.get(constant_1.FETCH_NOTIFICATIONS).catch(utils_1.errorHandler);
};
var fetchUnreadNotificationCount = function () {
    return wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_UNREAD_NOTIFICATIONS_COUNT)
        .catch(utils_1.errorHandler);
};
var postNotifications = function (params) {
    return wrapper_1.getClients()
        .restClient.post(constant_1.FETCH_NOTIFICATIONS, params)
        .catch(utils_1.errorHandler);
};
var markNotificationAsRead = function (id) {
    return postNotifications({ id: id, status: 'read' });
};
var markNotificationAsUnread = function (id) {
    return postNotifications({ id: id, status: 'created' });
};
var markAllNotificationsAsRead = function (ids) {
    return Promise.all(ids.map(markNotificationAsRead));
};
var markAllNotificationsAsUnread = function (ids) {
    return Promise.all(ids.map(markNotificationAsUnread));
};
var fetchRecentNotificationsByCount = function (count) {
    if (count === void 0) { count = 50; }
    return wrapper_1.getClients()
        .restClient.get(constant_1.FETCH_RECENT_NOTIFICATIONS + "?nb-notification=" + count)
        .catch(utils_1.errorHandler);
};
var notificationsApi = {
    fetchNotifications: fetchNotifications,
    fetchUnreadNotificationCount: fetchUnreadNotificationCount,
    postNotifications: postNotifications,
    markNotificationAsRead: markNotificationAsRead,
    markNotificationAsUnread: markNotificationAsUnread,
    markAllNotificationsAsRead: markAllNotificationsAsRead,
    markAllNotificationsAsUnread: markAllNotificationsAsUnread,
    fetchRecentNotificationsByCount: fetchRecentNotificationsByCount,
};
var init = function () { return notificationsApi; };
exports.init = init;
